var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from "react-query";
import { ReferralApi } from "../../services";
import { getUser } from "../../utils";
export const useValidateReferralCode = (referralCode) => {
    const { ciam_token } = getUser();
    const requestVerifyCodeMutation = useMutation("VERIFY_REFERRAL_CODE", ({ referralCode, ciam_token }) => ReferralApi.init().verifyCode(referralCode, ciam_token));
    const handleCodeValidation = () => __awaiter(void 0, void 0, void 0, function* () {
        const validateCode = yield requestVerifyCodeMutation.mutateAsync({ referralCode, ciam_token });
        return validateCode;
    });
    return Object.assign(Object.assign({}, requestVerifyCodeMutation), { handleCodeValidation });
};
//# sourceMappingURL=useValidateReferralCode.js.map